import { getFormProps, useForm } from "@conform-to/react";
import { parseWithZod } from "@conform-to/zod";
import { Block, Button, f7, Icon, List, ListInput } from "framework7-react";

import { signInBody, useSignIn } from "@/generated/api";
import { useRefetchCurrentUser } from "@/hooks/useRefetchCurrentUser";
import { useTokenStore } from "@/stores/tokenStore";

export function SignInForm() {
  const { setToken } = useTokenStore();

  const { refetch } = useRefetchCurrentUser();

  const { mutate, isPending } = useSignIn();

  const [form, fields] = useForm({
    defaultValue: {
      email: "",
      password: "",
    },
    onSubmit(event, { formData }) {
      event.preventDefault();

      const submission = parseWithZod(formData, { schema: signInBody });

      if (submission.status !== "success") {
        return submission.reply();
      }

      mutate(
        { data: submission.value },
        {
          onError: (error) => {
            f7.toast.create({
              closeTimeout: 2000,
              text: "ログインに失敗しました: " + error.errors.join("\n"),
            });
          },
          onSuccess: (response) => {
            if (response.status === 200) {
              const token = (response.headers["access-token"] as string | undefined) ?? "";
              const client = (response.headers["client"] as string | undefined) ?? "";
              const uid = (response.headers["uid"] as string | undefined) ?? "";
              setToken({ client, token, uid });
              refetch().finally(() => {
                window.location.reload();
              });
            }
          },
        },
      );
    },
    onValidate({ formData }) {
      return parseWithZod(formData, { schema: signInBody });
    },
    shouldValidate: "onBlur",
  });

  return (
    <form {...getFormProps(form)}>
      <List>
        <ListInput
          clearButton
          floatingLabel
          required
          validate
          autocomplete="email"
          errorMessage={fields.email.errors?.join("\n")}
          info="メールアドレスを入力してください"
          label="メールアドレス"
          name={fields.email.name}
          placeholder="user@timefill.me"
          type="email"
        >
          <Icon
            material="email"
            slot="media"
          />
        </ListInput>

        <ListInput
          clearButton
          floatingLabel
          required
          validate
          autocomplete="current-password"
          info="パスワードを入力してください"
          label="パスワード"
          name={fields.password.name}
          placeholder="password@123456"
          type="password"
        >
          <Icon
            material="key"
            slot="media"
          />
        </ListInput>
      </List>
      <Block>
        <Button
          fill
          large
          loading={isPending}
          type="submit"
        >
          ログイン
        </Button>
      </Block>
    </form>
  );
}
